import type { KeyboardEvent, MouseEvent } from 'react';

export const crmRowInteraction = (open: () => void) => ({
  tabIndex: 0,
  onClick: (event: MouseEvent<HTMLElement>) => {
    const target = event.target;
    if (
      event.defaultPrevented ||
      !(target instanceof Element) ||
      !event.currentTarget.contains(target) ||
      target.closest(
        'a, button, input, select, textarea, label, [role="button"], [role="combobox"], [contenteditable="true"]'
      )
    )
      return;
    open();
  },
  onKeyDown: (event: KeyboardEvent<HTMLElement>) => {
    if (
      event.target !== event.currentTarget ||
      event.defaultPrevented ||
      event.repeat ||
      !['Enter', ' '].includes(event.key)
    )
      return;
    event.preventDefault();
    open();
  },
});
